module.exports = __webpack_public_path__ + "img/video7.281e72cc.jpg";